var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c('router-view')],1),_c('snackbar'),_c('loader-indicator')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }